import { z } from "zod";
import type { AuditAction } from "../entities/index.js";

export const AuditQueryRequestSchema = z.object({
  entityType: z.string().optional(),
  entityId: z.string().uuid().optional(),
  action: z.string().optional(),
  userId: z.string().uuid().optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  offset: z.coerce.number().int().nonnegative().default(0),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});

export type AuditQueryRequest = z.infer<typeof AuditQueryRequestSchema>;

// Record<AuditAction, true> garante em compile-time que a lista cobre TODO o enum
// Prisma (sem faltar nem sobrar) — fonte do dropdown de filtro no FE.
const AUDIT_ACTION_MAP: Record<AuditAction, true> = {
  CREATE: true,
  UPDATE: true,
  DELETE: true,
  LOGIN: true,
  LOGOUT: true,
  ACKNOWLEDGE_ALARM: true,
  RESOLVE_ALARM: true,
  MARK_ALARM_FALSE: true,
  START_PRODUCTION: true,
  PAUSE_PRODUCTION: true,
  RESUME_PRODUCTION: true,
  FINISH_PRODUCTION: true,
  EXECUTE_SIMULATION: true,
  EXECUTE_AUTO_SIMULATION: true,
  CANCEL_AUTO_SIMULATION: true,
  SET_SIM_SIMILAR_MACHINE: true,
  LINK_SENSOR: true,
  UNLINK_SENSOR: true,
  CREATE_SCENARIO: true,
  APPLY_OVERRIDES: true,
  APPLY_SIM_PROFILE: true,
  CREATE_PRODUCT: true,
  UPDATE_PRODUCT: true,
  DELETE_PRODUCT: true,
  MANUAL_ENTRY: true,
  ROTATE_SENSOR_KEY: true,
  ROTATE_DEVICE_KEY: true,
  IMPORT: true,
  LAYOUT_UPDATE: true,
  CREATE_PRODUCTION_ORDER: true,
  UPDATE_PRODUCTION_ORDER: true,
  CANCEL_PRODUCTION_ORDER: true,
};

export const AUDIT_ACTIONS = Object.keys(AUDIT_ACTION_MAP) as AuditAction[];

export const AuditEntrySchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  // string (não z.enum): action nova no Prisma não pode derrubar a listagem com 500
  action: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  before: z.unknown(),
  after: z.unknown(),
  ipAddress: z.string().nullable(),
  traceId: z.string().nullable(),
  createdAt: z.string().datetime(),
});

export type AuditEntry = z.infer<typeof AuditEntrySchema>;

// Paginação dentro de `data` (não em `meta`): o api-client do FE desembrulha o
// envelope e devolve só `data` — `meta` não sobrevive ao client.
export const AuditListResponseSchema = z.object({
  items: z.array(AuditEntrySchema),
  total: z.number().int().nonnegative(),
  offset: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
});

export type AuditListResponse = z.infer<typeof AuditListResponseSchema>;

export const AuditEnvelopeSchema = z.object({ data: AuditListResponseSchema, error: z.null() });
